export const API_URL = "https://api.thanhren.vn";
export default API_URL;
